module.exports = __webpack_public_path__ + "img/i40_saloon.3d3cfeaa.png";